<div class="upiInputWrap">
  <form [formGroup]="upiForm" class="upiForm" (ngSubmit)="submit()">
    <!-- <div class="info mb-2">Enter upi using email/phone</div> -->
    <div class="radioGrps mb-2">
      <mat-radio-group formControlName="selectedOption" (change)="changeOption()">
        <div class="radioOption">
          <mat-radio-button *ngIf="recommendedVpa" id="lastUsedRadio" value="lastused">
            <div class="radioWrap">
              <div class="label">by last used</div>
              <div class="upiWrap"><div class="prefillText nowrap">{{recommendedVpa}}</div></div>
            </div>
          </mat-radio-button>
          <mat-radio-button id="emailRadio" *ngIf="cartDetails?.donor_email" value="email">
            <div class="radioWrap">
              <div class="label">by email</div>
              <div class="upiWrap">
                <div class="prefillText" [matTooltip]="cartDetails?.donor_email?.split('@')?.[0]">{{cartDetails?.donor_email?.split('@')?.[0]}}</div>
                <mat-form-field class="upiInput" [appearance]="'fill'">
                  <mat-label>Enter Handle Name</mat-label>
                  <input matInput [matAutocomplete]="autoEmail" formControlName="emailUpi" placeholder="E.g. @ybl" [disabled]="vars.upiTimer || selectedOption.value !== 'email'">
                  <mat-error *ngIf="emailUpiControl.hasError('pattern') && emailUpiControl.touched && selectedOption.value === 'email'">Invalid UPI ID</mat-error>
                  <mat-error *ngIf="emailUpiControl.hasError('required') && emailUpiControl.touched && selectedOption.value === 'email'">This field is required</mat-error>
                  <mat-autocomplete [hidden]="!emailUpiControl?.value?.match('@')" autoActiveFirstOption (optionSelected)="verifyUpi(emailUpiControl?.value)" #autoEmail="matAutocomplete">
                    <mat-option *ngFor="let option of emailUpiOptions | async" [value]="emailUpiControl?.value?.split('@')[0] + '@' + option">
                      {{emailUpiControl?.value?.split('@')[0] + '@' + option}}
                    </mat-option>
                  </mat-autocomplete>
                </mat-form-field>
              </div>
            </div>
          </mat-radio-button>
          <mat-radio-button id="phoneRadio" *ngIf="cartDetails?.donor_phone" value="phone">
            <div class="radioWrap">
              <div class="label">by phone</div>
              <div class="upiWrap">
                <div class="prefillText" [matTooltip]="cartDetails?.donor_phone?.split('@')?.[0]">{{cartDetails?.donor_phone?.split('@')?.[0]}}</div>
                <mat-form-field class="upiInput" [appearance]="'fill'">
                  <mat-label>Enter Handle Name</mat-label>
                  <input matInput [matAutocomplete]="autoPhone" formControlName="phoneUpi" placeholder="E.g. @ybl" [disabled]="vars.upiTimer || selectedOption.value !== 'email'">
                  <mat-error *ngIf="phoneUpiControl.hasError('pattern') && phoneUpiControl.touched && selectedOption.value === 'phone'">Invalid UPI ID</mat-error>
                  <mat-error *ngIf="phoneUpiControl.hasError('required') && phoneUpiControl.touched && selectedOption.value === 'phone'">This field is required</mat-error>
                  <mat-autocomplete [hidden]="!phoneUpiControl?.value?.match('@')" autoActiveFirstOption (optionSelected)="verifyUpi(phoneUpiControl?.value)" #autoPhone="matAutocomplete">
                    <mat-option *ngFor="let option of phoneUpiOptions | async" [value]="phoneUpiControl?.value?.split('@')[0] + '@' + option">
                      {{phoneUpiControl?.value?.split('@')[0] + '@' + option}}
                    </mat-option>
                  </mat-autocomplete>
                </mat-form-field>
              </div>
            </div>
          </mat-radio-button>
          <mat-radio-button id="customRadio" value="custom">
            <div class="radioWrap">
              <div class="label">other</div>
              <div class="upiWrap">
                <mat-form-field class="upiInput" [appearance]="'fill'">
                  <mat-label>Enter Full UPI Address</mat-label>
                  <input [matAutocomplete]="autoCustom" class="customInput" matInput formControlName="customUpi" placeholder="E.g. username@ybl" [disabled]="vars.upiTimer || selectedOption.value !== 'custom'">
                  <mat-error *ngIf="customUpiControl.hasError('pattern') && customUpiControl.touched &&selectedOption.value === 'custom'">Invalid UPI ID</mat-error>
                  <mat-error *ngIf="customUpiControl.hasError('required') && customUpiControl.touched &&selectedOption.value === 'custom'">This field is required</mat-error>
                  <mat-autocomplete [hidden]="!customUpiControl?.value?.match('@')" autoActiveFirstOption (optionSelected)="verifyUpi(customUpiControl?.value)" #autoCustom="matAutocomplete">
                    <mat-option *ngFor="let option of customUpiOptions | async" [value]="customUpiControl?.value?.split('@')[0] + '@' + option">
                      {{customUpiControl?.value?.split('@')[0] + '@' + option}}
                    </mat-option>
                  </mat-autocomplete>
                </mat-form-field>
              </div>
            </div>
          </mat-radio-button>
        </div>
      </mat-radio-group>
    </div>
    <app-donate-btn *ngIf="!isSip" label="Contribute" [btnClass]="'submit-payment'" [amount]="cartDetails?.donated_amount" [disabled]="vars.upiTimer || !selectedOption.value" [isOrderLoading]="isOrderLoading || vars.isOrderLoading" />
  </form>
</div>
